<template src="./template.html"></template>

<script>
import { mapActions, mapState } from 'vuex'
import { isEmpty, filter, find } from 'lodash'
import SingleSelectInput from '@/components/ui/SingleSelectInput'

export default {
  name: 'SearchFilter',
  components: {
    SingleSelectInput,
  },
  props: {
    ratingId: String,
  },
  data() {
    return {
      filters: {},
    }
  },
  computed: {
    ...mapState('ratings', ['filterOptions']),
    getDateType() {
      if (!isEmpty(this.filters.date_type)) {
        return this.filters.date_type.type
      }
      return false
    },
  },
  watch: {
    'filters.date_type'(val, oldVal) {
      if (val !== oldVal) {
        this.setDateValue(val)
      }
    },
  },
  created() {
    this.onResetFilter()
  },
  methods: {
    ...mapActions('ratings', [
      'getRatingFilters',
      'resetFilter',
      'updateFilters',
    ]),
    filterResults(identifier, props) {
      if (identifier === 'date') {
        return filter(props, i => i.type === this.getDateType)
      }
      return props
    },
    setDateValue(date) {
      if (date) {
        if (this.filterOptions && Array.isArray(this.filterOptions)) {
          this.filterOptions.forEach(e => {
            if (e.identifier === 'date') {
              const obj = find(e.properties, f => f.type === date.type)
              this.$set(this.filters, e.identifier, obj)
            }
          })
        }
      }
    },
    onResetFilter() {
      this.filters = {}
      this.resetFilter()
      this.getRatingFilters(this.ratingId).then(_ => {
        if (this.filterOptions && Array.isArray(this.filterOptions)) {
          this.filterOptions.forEach(e => {
            if (e.identifier === 'date_type' || e.identifier === 'date') {
              this.$set(this.filters, e.identifier, e.properties[0])
            }
          })
        }
      })
      this.$emit('onResetFilter')
    },
    onResultUpdate(id, args) {
      this.$set(this.filters, id, args)
      this.updateFilters(this.filters).then(_ => {
        this.$emit('filter')
      })
    },
  },
}
</script>
